/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { ClrDropdownModule } from "./dropdown/dropdown.module";
import { ClrTooltipModule } from "./tooltip/tooltip.module";
import { ClrSignpostModule } from "./signpost/signpost.module";
var ClrPopoverModule = (function () {
    function ClrPopoverModule() {
    }
    return ClrPopoverModule;
}());
export { ClrPopoverModule };
ClrPopoverModule.decorators = [
    { type: NgModule, args: [{
                exports: [
                    ClrDropdownModule,
                    ClrSignpostModule,
                    ClrTooltipModule
                ]
            },] },
];
/** @nocollapse */
ClrPopoverModule.ctorParameters = function () { return []; };
//# sourceMappingURL=popover.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/popover/popover.module.js
// module id = 203
// module chunks = 4